import Cookies from "js-cookie";
import MicroModal from "micromodal";
import { lock, unlock } from "tua-body-scroll-lock";

/**
 * Cookie popup controller
 */
export default class CookiePopupController {
    constructor() {
        /**
         * DOM Elements
         * @type {{cookieAnalytics: string, cookieAds: string, cookiePopup: string, cookies: {analytics: string, ads: string, main: string}, cookiePopupClose: string}}
         */
        this.DOM = {
            cookiePopup: ".js-cookie-popup",
            cookiePopupClose: ".js-cookie-popup-close",
            cookiePopupEdit: ".js-cookie-popup-edit",
            cookieAnalytics: "#cookieAnalytics",
            cookieAds: "#cookieAds",
            cookies: {
                main: "cookiePopup",
                analytics: "cookieAnalytics",
                ads: "cookieAds",
            },
        };

        /**
         * fetch cookie popup DOM element
         * @type {Element}
         */
        this.cookiePopup = document.querySelector(this.DOM.cookiePopup);
    }

    /**
     * Init
     */
    init() {
        if (this.cookiePopup === null) {
            return;
        }
        this.startEvents();
    }

    /**
     * Start cookie popup events
     */
    startEvents() {
        const closeButton = this.cookiePopup.querySelector(
            this.DOM.cookiePopupClose,
        );
        const cookieAnalytics = this.cookiePopup.querySelector(
            this.DOM.cookieAnalytics,
        );
        const cookieAds = this.cookiePopup.querySelector(this.DOM.cookieAds);
        const cookieEdit = document.querySelector(this.DOM.cookiePopupEdit);
        const expireTime = new Date(new Date().getTime() + 525600 * 60 * 1000);
        if (Cookies.get(this.DOM.cookies.main) !== "true") {
            MicroModal.show("cookie-modal", {
                onShow: (modal) => {
                    console.log(`${modal.id} is shown`);
                    lock(this.cookiePopup.firstChild);
                },
                onClose: (modal) => {
                    console.log(`${modal.id} is hidden`);
                    unlock(this.cookiePopup.firstChild);
                },
            });
            closeButton.addEventListener("click", (event) => {
                event.preventDefault();
                MicroModal.close("cookie-modal");
                if (cookieAnalytics.checked === true) {
                    Cookies.set(this.DOM.cookies.analytics, "on", {
                        expires: expireTime,
                    });
                }
                if (cookieAds.checked === true) {
                    Cookies.set(this.DOM.cookies.ads, "on", {
                        expires: expireTime,
                    });
                }
                Cookies.set(this.DOM.cookies.main, "true", {
                    expires: expireTime,
                });
                location.reload();
            });
        } else {
            if (Cookies.get(this.DOM.cookies.analytics) === "on") {
                cookieAnalytics.checked = true;
            } else {
                cookieAnalytics.checked = false;
            }
            if (Cookies.get(this.DOM.cookies.ads) === "on") {
                cookieAds.checked = true;
            } else {
                cookieAds.checked = false;
            }
            if (cookieEdit) {
                cookieEdit.addEventListener("click", (event) => {
                    event.preventDefault();
                    MicroModal.show("cookie-modal", {
                        onShow: (modal) => {
                            console.log(`${modal.id} is shown`);
                            lock(this.cookiePopup.firstChild);
                        },
                        onClose: (modal) => {
                            console.log(`${modal.id} is hidden`);
                            unlock(this.cookiePopup.firstChild);
                        },
                    });
                });
            }
            closeButton.addEventListener("click", (event) => {
                event.preventDefault();
                MicroModal.close("cookie-modal");
                if (cookieAnalytics.checked === true) {
                    Cookies.set(this.DOM.cookies.analytics, "on", {
                        expires: expireTime,
                    });
                } else {
                    Cookies.remove(this.DOM.cookies.analytics);
                }
                if (cookieAds.checked === true) {
                    Cookies.set(this.DOM.cookies.ads, "on", {
                        expires: expireTime,
                    });
                } else {
                    Cookies.remove(this.DOM.cookies.ads);
                }
                Cookies.set(this.DOM.cookies.main, "true", {
                    expires: expireTime,
                });
                location.reload();
            });
        }
    }
}

/**
 * check if user has accepted analytics
 * @returns {"on"|undefined}
 */
window.cookieAnalytics = function () {
    return Cookies.get("cookieAnalytics");
};

/**
 * check if user has accepted ads
 * @returns {"on"|undefined}
 */
window.cookieAds = function () {
    return Cookies.get("cookieAds");
};
